import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, Fragment as _Fragment } from "vue"
import _imports_0 from '../assets/loading.gif'


const _hoisted_1 = {
  key: 0,
  class: "dialog-box"
}
const _hoisted_2 = { class: "dialog-action" }
const _hoisted_3 = { class: "dialog-text-area" }
const _hoisted_4 = { class: "error" }
const _hoisted_5 = { class: "dialog-button-area" }
const _hoisted_6 = { key: 2 }
const _hoisted_7 = {
  key: 0,
  class: "l-modal"
}

import { ref, watch } from "vue";
import * as yup from "yup";
import { Form, Field, ErrorMessage } from "vee-validate";
import CommonButton from "./CommonButton.vue";
import { updateUserSnsAccountRequest } from "../types/apiRequest";
import { UserInfoStore } from "../store/UserInfoStore";
import { MEDIA_NAME } from "../consts/common";
import router from "../router";

// APIを公開
export type Props = {
  modelValue: boolean;
  mediaType: number;
  accountName: string;
};

// dialogの参照を保持する変数

export default /*@__PURE__*/_defineComponent({
  __name: 'SnsAccountDialog',
  props: {
    modelValue: { type: Boolean },
    mediaType: {},
    accountName: {}
  },
  emits: ["update:modelValue"],
  setup(__props: any, { expose: __expose, emit: __emit }) {

__expose({
  openDialog,
  closeDialog,
});

const dialog = ref<HTMLDialogElement | null>(null);
// const open = ref(false);
const userInfoStore = UserInfoStore();
const emit = __emit;
const props = __props;
const name = ref("");
const title = ref("登録");

const loading = ref(false);
// const message = ref("");
const validationSchema = ref(
  yup.object().shape({
    name: yup
      .string()
      .trim()
      .required("アカウント名は必須です")
      .min(1)
      .matches(/^[ -~]+$/, "アカウント名は@を除き半角で入力してください")
      .matches(/^(?!.*@).*$/, "アカウント名は@を除き半角で入力してください")
      .label("アカウント名"),
  })
);

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const click = async ($event: any) => {
  if (!$event || !$event.target) {
    name.value = "";
    title.value = "登録";
    emit("update:modelValue", false);
    dialog?.value?.close();
  }
};

// //ダイアログのクリックイベント
// contactDialog.addEventListener('click', (event) => {

//   if(!event || !event.target || (event.target as HTMLElement).closest('.dialog-action') === null) {
//     dialog?.value?.close();
//   }
// });

async function registSnsAccount() {
  loading.value = true;
  const req: updateUserSnsAccountRequest = {
    media_type: props.mediaType,
    account_name: name.value,
  };
  await userInfoStore.updateUserSnsAccount(req);
  emit("update:modelValue", false);
  name.value = "";
  title.value = "登録";
  loading.value = false;

  dialog?.value?.close();
}

async function updateUserSnsInfo() {
  loading.value = true;
  const req: updateUserSnsAccountRequest = {
    media_type: props.mediaType,
    account_name: name.value,
  };
  await userInfoStore.updateUserSnsAccount(req);
  name.value = "";
  title.value = "登録";
  emit("update:modelValue", false);
  loading.value = false;
  // 案件詳細→ユーザー登録から遷移の場合は案件詳細に戻る
  if (window.history.state.back == "/sign-up") {
    router.go(-2);
  }
  dialog?.value?.close();
}

async function deleteSnsAccout() {
  loading.value = true;
  await userInfoStore.deleteUserSnsAccount(props.mediaType);
  emit("update:modelValue", false);
  loading.value = false;
  title.value = "登録";
  dialog?.value?.close();
}

// 外部に公開するAPI。ダイアログを開いて、終了
function openDialog() {
  // open.value = true;
  dialog?.value?.showModal();
}
function closeDialog() {
  // open.value = true;
  name.value = "";
  dialog?.value?.close();
  emit("update:modelValue", false);
  title.value = "登録";
}

// ボタンが押されたときに呼ばれるコールバック
async function onDialogAction(action: boolean) {
  if (action) {
    if (props.accountName) updateUserSnsInfo();
    else await registSnsAccount();
  } else {
    await deleteSnsAccout();
    dialog?.value?.close();
  }
  emit("update:modelValue", false);
}

watch<boolean>(
  () => props.modelValue,
  () => {
    name.value = props.accountName;
    title.value = props.accountName ? "更新" : "登録";
  }
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("dialog", {
      ref_key: "dialog",
      ref: dialog,
      class: "dialog",
      onClick: _cache[3] || (_cache[3] = ($event: any) => (click($event))),
      style: _normalizeStyle([_ctx.modelValue ? 'z-index: 999;' : 'z-index: 0;  visibility: hidden;'])
    }, [
      (_ctx.modelValue)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", {
              class: "close",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (closeDialog()))
            }),
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("p", null, _toDisplayString(_unref(MEDIA_NAME)[_ctx.mediaType]) + "アカウント" + _toDisplayString(title.value), 1 /* TEXT */),
              _cache[5] || (_cache[5] = _createElementVNode("p", null, "@を除いたアカウント名を入力してください", -1 /* HOISTED */)),
              _createVNode(_unref(Form), {
                class: "form",
                validationSchema: validationSchema.value
              }, {
                default: _withCtx(({ meta: { valid } }) => [
                  _createElementVNode("div", _hoisted_3, [
                    _createVNode(_unref(Field), {
                      type: "text",
                      modelValue: name.value,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((name).value = $event)),
                      name: "name",
                      placeholder: "アカウント名",
                      class: "text-field",
                      tabindex: "1"
                    }, null, 8 /* PROPS */, ["modelValue"]),
                    _createElementVNode("div", null, [
                      _createVNode(_unref(ErrorMessage), { name: "name" }, {
                        default: _withCtx(({ message }) => [
                          _createElementVNode("span", _hoisted_4, _toDisplayString(message), 1 /* TEXT */)
                        ]),
                        _: 1 /* STABLE */
                      })
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_5, [
                    (!loading.value)
                      ? (_openBlock(), _createBlock(CommonButton, {
                          key: 0,
                          data: {
                status: !valid ? 2 : 0,
                button: _ctx.accountName ? `更新` : `登録`,
              },
                          onClick: ($event: any) => (!valid ? '' : onDialogAction(true))
                        }, null, 8 /* PROPS */, ["data", "onClick"]))
                      : _createCommentVNode("v-if", true),
                    (_ctx.accountName && !loading.value)
                      ? (_openBlock(), _createBlock(CommonButton, {
                          key: 1,
                          data: {
                status: 3,
                button: `削除`,
              },
                          onClick: _cache[2] || (_cache[2] = ($event: any) => (onDialogAction(false)))
                        }))
                      : _createCommentVNode("v-if", true),
                    (loading.value)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_6, _cache[4] || (_cache[4] = [
                          _createElementVNode("img", {
                            src: _imports_0,
                            class: "loading"
                          }, null, -1 /* HOISTED */)
                        ])))
                      : _createCommentVNode("v-if", true)
                  ])
                ]),
                _: 1 /* STABLE */
              }, 8 /* PROPS */, ["validationSchema"])
            ])
          ]))
        : _createCommentVNode("v-if", true)
    ], 4 /* STYLE */),
    (_ctx.modelValue)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _createElementVNode("div", {
            class: _normalizeClass([_ctx.modelValue ? 'l-modal__bg' : ''])
          }, null, 2 /* CLASS */)
        ]))
      : _createCommentVNode("v-if", true)
  ], 64 /* STABLE_FRAGMENT */))
}
}

})